import React from 'react';
import { useParams } from 'react-router-dom';
import { useBookings } from '../../../../hooks/accommodation';
import { useAppSelector } from '../../../../hooks/useRedux';
import { selectAccommodationProperty } from '../../../../store/accommodation';

export const BookingFinancialsCard: React.FC = () => {
  const { bookingId } = useParams<{ bookingId: string }>();
  const property = useAppSelector(selectAccommodationProperty);
  const { data: bookings = [] } = useBookings(property?.id);
  const booking = bookings.find((b) => b.id === bookingId) ?? null;

  if (!booking) return null;

  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-5 space-y-3.5">
      <h4 className="text-xs font-semibold uppercase tracking-wide text-gray-500 pb-2 border-b border-gray-100">
        Financials
      </h4>
      <div className="space-y-2">
        <div className="flex justify-between text-sm">
          <span className="text-gray-500 font-medium">Total amount</span>
          <span className="font-semibold text-gray-900">
            {booking.currency} {booking.total_amount.toLocaleString()}
          </span>
        </div>
        <div className="flex justify-between text-sm">
          <span className="text-gray-500 font-medium">Amount paid</span>
          <span className="font-semibold text-emerald-600">
            {booking.currency} {booking.amount_paid.toLocaleString()}
          </span>
        </div>
        <div className="flex justify-between border-t border-gray-100 pt-2 text-sm">
          <span className="text-gray-500 font-medium">Balance due</span>
          <span className="font-bold text-gray-900">
            {booking.currency}{' '}
            {(booking.total_amount - booking.amount_paid).toLocaleString()}
          </span>
        </div>
      </div>
    </div>
  );
};
